import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/32_card_back_lion/32_card_back_lion"
 * Contains 1 texture(s)
 */
export class CardsBacks32CardBackLionAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/32_card_back_lion/32_card_back_lion';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '32_lion.png'
    ] as const;
}
